<!-- 我的联盟采购单 -->
<template>
    <div class="business-content-main trans-to-purchase-order">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.add" @click="gotoCreateUnionOrder">{{ permission.add }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">联盟单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.UnionOrderCode" placeholder="请输入联盟单号"></el-input>
                <div class="search-name">我的采购单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.MyOrderCode" placeholder="请输入采购单号"></el-input>
                <div class="search-name">创建日期</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" ref="multipleTable" border style="width: 100%">
                <el-table-column width="180" prop="UnionOrderCode" label="联盟单号">
                    <template slot-scope="scope">
                        <div v-if="scope.row.State == 1 && scope.row.UOIsConfirm && !scope.row.UOIsCancel && !scope.row.UOIsDel">
                            <el-badge value="已确认" class="mark">
                                <div v-if="scope.row.State == 1 && scope.row.UOIsConfirm" style="color: #409eff" @click="gotoUnionOrderDetail(scope.row)" type="text">
                                    {{ scope.row.UnionOrderCode }}
                                </div>
                            </el-badge>
                        </div>
                        <div v-else-if="scope.row.State == 1 && !scope.row.UOIsConfirm && !scope.row.UOIsCancel && !scope.row.UOIsDel">
                            <el-badge value="等待确认" class="mark" type="warning">
                                {{ scope.row.UnionOrderCode }}
                            </el-badge>
                        </div>
                        <div v-else-if="scope.row.State == 1 && scope.row.UOIsCancel && !scope.row.UOIsDel">
                            <el-badge value="已撤销" class="mark" type="danger">
                                {{ scope.row.UnionOrderCode }}
                            </el-badge>
                        </div>
                        <div v-else-if="scope.row.State == 1 && scope.row.UOIsDel">
                            <el-badge value="已删除" class="mark" type="danger">
                                {{ scope.row.UnionOrderCode }}
                            </el-badge>
                        </div>
                        <div v-else-if="scope.row.State == 1 && scope.row.UOIsConfirm && scope.row.UOIsDelivery">
                            <el-badge value="已发货" class="mark" type="danger">
                                {{ scope.row.UnionOrderCode }}
                            </el-badge>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column width="160" prop="MyOrderCode" label="我的采购单号" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.State == 1" style="color: #409eff" @click="gotoMyOrderDetail(scope.row.MyOrderId)" type="text">
                            {{ scope.row.MyOrderCode }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column width="120" prop="PayTypeName" label="支付方式" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="OrderAmount" label="采购总额" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="ShipAmount" label="运费"></el-table-column>
                <el-table-column prop="CalcAmount" label="合计" show-overflow-tooltip></el-table-column>
                <el-table-column prop="StateName" label="订单状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="WarehouseName" label="指定入仓仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="90" prop="SName" label="采购员" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" prop="UpdateTime" label="最后更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit && scope.row.State == 5" title="编辑联盟订单" size="mini" type="text" @click="gotoEditUnionOrders(scope.row)">{{
                                permission.edit
                            }}</el-button>
                            <el-button
                                v-if="permission.submit && scope.row.State == 5"
                                title="提交联盟订单"
                                size="mini"
                                type="text"
                                @click="submitUnionOrder(scope.row.MyOrderId)"
                                >{{ permission.submit }}</el-button
                            >
                            <el-button
                                v-if="permission.del && (scope.row.State == 5 || scope.row.UOIsCancel || scope.row.UOIsDel)"
                                title="删除联盟订单"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delUnionOrder(scope.row.MyOrderId)"
                                >{{ permission.del }}</el-button
                            >
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{ permission.opRecords }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="联盟订单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <OrdersLifes :OrderId="OrderId" :OrderType="4" @closeDialog="closeOrderLifesDialog"></OrdersLifes>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import OrdersLifes from '@/components/entpUnion/orderManage/unionOrdersLifes';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        OrdersLifes
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            dateTimes: '',
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                MyOrderCode: '',
                UnionOrderCode: '',
                StartDate: '',
                EndDate: '',
                State: '0',
                Page: 1,
                limit: 15
            },
            tableData: [], //列表数据
            tableDataLength: 0,
            permission: {},
            orderStates: [
                { Text: '全部', Value: '-1' },
                { Text: '未采购', Value: '0' },
                { Text: '部分采购', Value: '1' },
                { Text: '已采购', Value: '2' }
            ],
            verifyStates: [
                { Text: '全部', Value: '-1' },
                { Text: '已核实', Value: '1' },
                { Text: '未核实', Value: '0' }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            OrderLifesVisible: false,
            OrderId: ''
        };
    },
    mounted() {
        this.permission = this.$util.getUnionPermission('MyUnionOrders');
        this.getTableData();
    },
    methods: {
        gotoCreateUnionOrder() {
            this.getUnionReleResults().then(data => {
                if (data.IsRele && data.EntpCusId) {
                    this.$router.push('/entpUnion/unionOrdersManage/tranUnionOrders?entpCusId=' + data.EntpCusId + '&entpCusName=' + data.EntpCusName + '&type=0');
                } else this.$util.warningMsg('未进行实体关联或联盟本实体不能进行下单');
            });
        },
        // 跳转联盟下单页面
        gotoEditUnionOrders(row) {
            this.$router.push(`/entpUnion/unionOrdersManage/tranUnionOrders?type=2&orderId=${row.MyOrderId}`);
        },
        gotoMyOrderDetail(MyOrderId) {
            this.$router.push(`/entpUnion/unionOrdersManage/tranUnionOrders?type=1&orderId=${MyOrderId}`);
        },
        gotoUnionOrderDetail(row) {
            this.$router.push(`/entpUnion/unionOrdersManage/opUnionSaleOrders?type=3&orderId=${row.SaleOrderId}`);
        },
        //获取销售单转采购的列表
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnionOrders/GetMyUnionOrders',
                    data: this.searchData,
                    hideLoading: false
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                MyOrderCode: '',
                UnionOrderCode: '',
                StartDate: '',
                EndDate: '',
                State: '0',
                Page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        submitUnionOrder(myOrderId) {
            let that = this;
            if (myOrderId) {
                that.$confirm('您确认提交该联盟订单吗？一旦提交将无法进行修改联盟，届时如需修改，请找联盟管理员', '提示', {
                    confirmButtonText: '确定继续提交',
                    cancelButtonText: '我再确认一下',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnionOrders/SubmitUnionOrder',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    UnionOrderId: myOrderId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        delUnionOrder(myOrderId) {
            let that = this;
            if (myOrderId) {
                that.$confirm('您确认删除该联盟订单吗？一旦删除，将无法进行恢复', '提示', {
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '我再想想',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnionOrders/DelUnionOrder',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    UnionOrderId: myOrderId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg(res.errmsg);

                                    for (let i = 0; i < that.tableData.length; i++) {
                                        if (that.tableData[i].MyOrderId == myOrderId) {
                                            that.tableData.splice(i, 1);
                                            return;
                                        }
                                    }
                                }
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getUnionReleResults() {
            let that = this;
            return new Promise(resolve => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpUnions/GetUnionReleResults',
                        data: {
                            UnionId: that.searchData.UnionId
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            if (!data.IsRele && !data.IsMine) {
                                that.releEntpId = data.ReleEntpId;
                                that.$confirm('您还没有对联盟拥有者进行实体关联，关联之前无法进行下单哟', '提示', {
                                    confirmButtonText: '提取实体',
                                    cancelButtonText: '关联实体',
                                    type: 'warning',
                                    center: false,
                                    distinguishCancelAndClose: true
                                })
                                    .then(() => {
                                        that.dialogFetchVisible = true;
                                    })
                                    .catch(action => {
                                        if (action === 'cancel') {
                                            that.dialogReleVisible = true;
                                        }
                                    });
                            } else resolve(data);
                        } else that.$util.warningMsg(res.errmsg);
                    });
            });
        },

        opRecords(item) {
            let id = item ? item.UnionOrderId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('联盟订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.table-ctn {
    height: calc(100% - 162px);
    overflow-y: auto;
}
.search-item {
    width: 150px;
}
</style>
<style lang="less">
.trans-to-purchase-order {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
    .el-table__row {
        td:nth-child(1) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
